module.exports = __webpack_public_path__ + "img/pdf.0d8ea920.svg";